<h1 mat-dialog-title>Issue manual adjustment</h1>
<mat-horizontal-stepper [linear]="true" #stepper>
  <mat-step [stepControl]="formGroup">
    <form [formGroup]="formGroup" (submit)="submit()">
      <ng-template matStepLabel>Fill out the form</ng-template>
      @if (formGroup) {
        <form [formGroup]="formGroup">
          <ngx-spinner></ngx-spinner>
          <div mat-dialog-content class="dialog-content">
            <div class="dialog-title">Type</div>
            <mat-radio-group formControlName="type">
              @for (type of types; track type) {
                <mat-radio-button class="radio-element" [value]="type.code" color="primary">
                  <b class="item-info">{{ type.name }}</b>
                </mat-radio-button>
                <div class="item-description">
                  {{ type.description }}
                </div>
              }
            </mat-radio-group>
            @if (formGroup.get('type').hasError('required') && submitted) {
              <mat-error> Type field is required </mat-error>
            }
            @if (balance) {
              <div class="all-balances">
                <app-manual-adjustment-cash
                  [data]="cashAdjustmentInput"
                  (deltaChange)="cashChanged($event)"></app-manual-adjustment-cash>
                @if (formGroup.get('cashSummary').hasError('zeroDelta') && submitted) {
                  <mat-error> Delta can't be zero, if you don't want to adjust cash uncheck the checkbox </mat-error>
                }
                @if (formGroup.get('cashSummary').hasError('nonNegative') && submitted) {
                  <mat-error> Balance after adjustment can't be negative. </mat-error>
                }
                <app-manual-adjustment-cash
                  [data]="bonusAdjustmentInput"
                  [enabled]="bonusEnabled()"
                  (deltaChange)="bonusChanged($event)"></app-manual-adjustment-cash>
                @if (formGroup.get('bonusSummary').hasError('zeroDelta') && submitted) {
                  <mat-error> Delta can't be zero, if you don't want to adjust bonus uncheck the checkbox </mat-error>
                }
                @if (formGroup.get('bonusSummary').hasError('nonNegative') && submitted) {
                  <mat-error> Balance after adjustment can't be negative. </mat-error>
                }
                <app-manual-adjustment-diamonds
                  [current]="balance.diamonds"
                  [currency]="balance.cash.currency"
                  (deltaChanged)="diamondsChanged($event)"></app-manual-adjustment-diamonds>
                @if (formGroup.get('diamondsSummary').hasError('zeroDelta') && submitted) {
                  <mat-error>
                    Delta can't be zero, if you don't want to adjust diamonds uncheck the checkbox
                  </mat-error>
                }
                @if (formGroup.get('diamondsSummary').hasError('nonNegative') && submitted) {
                  <mat-error> Balance after adjustment can't be negative. </mat-error>
                }
                <app-manual-adjustment-cash
                  [data]="reserveAdjustmentInput"
                  [enabled]="reserveEnabled()"
                  (deltaChange)="reserveChanged($event)"></app-manual-adjustment-cash>
                @if (formGroup.get('reserveSummary').hasError('zeroDelta') && submitted) {
                  <mat-error> Delta can't be zero, if you don't want to adjust reserve uncheck the checkbox </mat-error>
                }
                @if (formGroup.get('reserveSummary').hasError('nonNegative') && submitted) {
                  <mat-error> Reserve after adjustment can't be negative. </mat-error>
                }
              </div>
            }
            @if (formGroup.hasError('noDelta') && submitted) {
              <mat-error> At least one delta has to be specified for cash, bonus, diamonds or reserve. </mat-error>
            }
            <mat-label class="input-label">Internal reason*</mat-label>
            <mat-hint
              >Why are you issuing this adjustment? Provide as much details as possible. This will not be shown to the
              player.
            </mat-hint>
            <mat-form-field>
              <textarea formControlName="internalReason" matInput></textarea>
            </mat-form-field>
            @if (formGroup.get('internalReason').hasError('required') && submitted) {
              <mat-error> Internal reason field is required </mat-error>
            }
            <mat-label class="input-label">Public reason*</mat-label>
            <mat-hint
              >WARNING: This will be shown to the player when they look at the details for transaction. Keep it
              brief.</mat-hint
            >
            <mat-form-field>
              <textarea formControlName="publicReason" matInput></textarea>
            </mat-form-field>
            @if (formGroup.get('publicReason').hasError('required') && submitted) {
              <mat-error> Public reason field is required </mat-error>
            }
            <mat-label class="input-label"
              >Reference ID(s)
              @if (this.formGroup.value.type === 'MANUAL_OFFER') {
                <span>*</span>
              }
            </mat-label>
            <mat-hint>
              Provide as many reference IDs as is applicable, separated by a comma.<br />
              Generally try to always include a Zendesk ticket ID if applicable, an offer ID (required for manual offer)
              and/or a Jira ticket ID (optional for a technical issue)
            </mat-hint>
            <mat-form-field>
              <input formControlName="referenceIds" matInput />
            </mat-form-field>
            @if (formGroup.get('referenceIds').hasError('required') && submitted) {
              <mat-error> Reference IDs field is required for manual offer </mat-error>
            }
            <div color="accent" class="item-note">
              <b>NOTE:</b> Make sure to double-check all figures to ensure they are correct and that your submission is
              authorised and within approved limits according to our policies. All manual credits are frequently
              audited.
            </div>
          </div>
        </form>
      }
      <div>
        <button mat-raised-button mat-dialog-close="" class="cancel-button">Cancel</button>
        <button mat-raised-button color="primary" matStepperNext="" type="submit" (click)="submitted = true">
          Submit
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step>
    <form>
      <ng-template matStepLabel>Confirm</ng-template>
      @if (summary) {
        <app-manual-adjustment-confirmation [summary]="summary"></app-manual-adjustment-confirmation>
      }
      <div class="actions-container">
        <button mat-raised-button color="accent" matStepperPrevious (click)="makeChanges()">Make changes</button>
        <button #button mat-raised-button color="primary" (click)="authorise(stepper, button)">Authorise</button>
      </div>
    </form>
  </mat-step>
  <mat-step>
    <form>
      <ng-template matStepLabel>Done</ng-template>
      <div class="adjust-balance-info">Player balances have been adjusted!</div>
      <div class="close-info">
        <button mat-raised-button color="primary" mat-dialog-close="">Close</button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
